import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link , useParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {formatDate} from "../../utils/helper";
import { getGenericStatus } from '../../utils/statusHelper';


const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [banners, setBanners] = useState([]);
    const [pagination, setPagination] = useState({});
    const [apiData, setApiData] = useState({
        search: "",
        daterange: "",
        page: 1,
    });
   
    
    useEffect(() => {
        getBanners();
    }, [apiData.page, apiData.search, apiData.daterange,]); // Dependency array for re-fetching data

    const getBanners = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "admin/banners",
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setBanners(data.data.banners || []);
                setPagination(data.data.pagination || {});
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: '',
            page: 1
        });
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            image: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'no',
        });

        if (result.isConfirmed) {
            try {
                setIsLoader(true);
                const response = await ApiService.request({
                    method: "DELETE",
                    url: `admin/banners/${id}`,
                });
                const data = response.data;
                if (data.status) {
                    getBanners();
                    toast.success(data.message);
                } else {
                    toast.error(data.message);
                }
                setIsLoader(false);
            } catch (error) {
                setIsLoader(false);
            }
        }
    };

 

    const updateStatus = async (banner) => {
        const newStatus = !banner.status;
        
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `Change status to ${newStatus ? 'Active' : 'Inactive'}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            try {
                setIsLoader(true);
                const response = await ApiService.request({
                    method: "POST",
                    url: `admin/banners/${banner.id}/status`,
                    data: { status: newStatus }
                });
                const data = response.data;
                if (data.status) {
                    getBanners();
                    toast.success(data.message);
                } else {
                    toast.error(data.message);
                }
                setIsLoader(false);
            } catch (error) {
                setIsLoader(false);
            }
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                           {("Banners")}</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">{("Banners")}</li>
                        </ul>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <OverlayTrigger placement="top" overlay={<Tooltip>Add New Banner</Tooltip>}>
                            <Link to={`/banners/add`} className='btn btn-base btn-sm'>Add New Banner</Link>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-banners-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder={("Search Banner title..")} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div id="kt_banners_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>Image</th>
                                                <th>Title</th>
                                                <th>Link</th>
                                                <th>Sort Order</th>
                                                <th>Status</th>
                                                <th>Created Date</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {banners.length > 0 ? banners.map((banner, index) => (
                                                <tr key={banner.id}>
                                                    <td>
                                                        <img src={banner.image} alt="banner" className="w-50px h-50px object-cover rounded" />
                                                    </td>
                                                    <td>{banner.title}</td>
                                                    <td>
                                                        {banner.link ? (
                                                            <a href={banner.link} target="_blank" rel="noopener noreferrer" className="text-primary">
                                                                {banner.link.length > 30 ? banner.link.substring(0, 30) + '...' : banner.link}
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted">No link</span>
                                                        )}
                                                    </td>
                                                    <td>{banner.sort_order || 0}</td>
                                                    <td>
                                                        <button className="p-0 btn btn-transparent">
                                                            {(() => {
                                                                const { badgeClass, label } = getGenericStatus(banner.status);
                                                                return (
                                                                    <span 
                                                                        className={`badge ${badgeClass}`} 
                                                                        onClick={() => updateStatus(banner)}
                                                                    >
                                                                        {label}
                                                                    </span>
                                                                );
                                                            })()}
                                                        </button>
                                                    </td>
                                                    <td>{formatDate(banner.created_at, 'DD MMM YYYY, hh:mm A')}</td>
                                                    <td className="mt-2">
                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Edit Banner</Tooltip>}>
                                                            <Link 
                                                                to={`/banners/edit/${banner.id}`} 
                                                                className="btn btn-sm h-30px btn-light-primary me-1"
                                                            >
                                                                <i className="fas fa-pencil-alt fs-6"></i>
                                                            </Link>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger placement="top" overlay={<Tooltip>Delete Banner</Tooltip>}>
                                                            <button 
                                                                onClick={() => delData(banner.id)} 
                                                                className="btn btn-sm h-30px btn-light-danger"
                                                            >
                                                                <i className="fas fa-trash-alt fs-6"></i>
                                                            </button>
                                                        </OverlayTrigger>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="7" className="text-dark text-center mt-2">No data found!!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> 
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center"  />
                                    )}

                                    {pagination.last_page > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
